import type { HttpErrorResponse } from '@angular/common/http';

import { createActions, ngrxEvent } from '@core/ngrx-legacy';

import type { ViewboxEEOAnswers, ViewboxEEOAnswersDictionary, ViewboxEEOData } from './types';

const namespace = 'viewboxEEO';

export const ViewboxEEOActions = createActions(namespace, {
  load: ngrxEvent<{ token: string }>(),
  loadSuccess: ngrxEvent<ViewboxEEOData>(),
  loadFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
  loadAnswersDictionary: ngrxEvent<void>(),
  loadAnswersDictionarySuccess: ngrxEvent<ViewboxEEOAnswersDictionary>(),
  loadAnswersDictionaryFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
  saveAnswers: ngrxEvent<{
    token: string;
    params: ViewboxEEOAnswers;
  }>(),
  saveAnswersSuccess: ngrxEvent<any>(),
  saveAnswersFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
});
